const ResourceTaskCard = ({ task, color, onClick }) => (
  <div
    onClick={() => onClick(task)}
    title={task.assignedTo}
    onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,0.14)")}
    onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.07)")}
    style={{
      borderLeft: `4px solid ${color.border}`,
      background: color.bg,
      borderRadius: "0 8px 8px 0",
      padding: "8px 10px",
      cursor: "pointer",
      minHeight: 96,
      height: "100%",
      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
      transition: "box-shadow 0.18s",
      display: "flex",
      flexDirection: "column",
      gap: 4,
    }}
  >
    {/* Row 1: Name (left) + Designation (right) */}
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 4 }}>
      <span style={{
        fontWeight: 700,
        fontSize: 12,
        color: color.border,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        flex: 1,
      }}>
        {task.assignedTo}
      </span>
      {task.designation && task.designation !== "—" && (
        <span style={{
          fontSize: 9,
          fontWeight: 700,
          color: color.tagColor,
          background: color.tagBg,
          border: `1px solid ${color.border}`,
          padding: "2px 6px",
          borderRadius: 999,
          whiteSpace: "nowrap",
          flexShrink: 0,
          letterSpacing: "0.04em",
        }}>
          {task.designation}
        </span>
      )}
    </div>

    {/* Row 2: Client */}
    <div style={{ fontSize: 11, fontWeight: 600, color: "#334155", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
      {task.client}
    </div>

    {/* Row 3: Project name + Task Completed tag */}
    <div style={{
      marginTop: "auto",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between",
      gap: 4,
    }}>
      <div style={{
        fontSize: 10,
        color: "#6c757d",
        fontStyle: "italic",
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        lineHeight: 1.45,
        flex: 1,
      }}>
        {task.project}
      </div>
      {task.isTaskCompleted && (
        <span style={{
          flexShrink: 0,
          fontSize: 9,
          fontWeight: 700,
          color: "#0a3622",
          background: "#d1e7dd",
          border: "1px solid #a3cfbb",
          borderRadius: 999,
          padding: "2px 6px",
          letterSpacing: "0.04em",
          whiteSpace: "nowrap",
        }}>
          Task Completed
        </span>
      )}
    </div>

    {/* Row 4: Notes */}
    {task.notes && task.notes !== "—" && (
      <div style={{
        fontSize: 10,
        color: "#475569",
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        lineHeight: 1.45,
      }}>
        {task.notes}
      </div>
    )}
  </div>
);

export default ResourceTaskCard;